import store from './store'

console.log(window.location, 'window.locationwindow.locationwindow.location', process.env.VUE_APP_TEAMS_KNOWLEDGE)
const microApps = [
  // {
  //   name: 'sub-react',
  //   entry: process.env.VUE_APP_SUB_REACT,
  //   activeRule: '/sub-react'
  // },
  // {
  //   name: 'react',
  //   // entry: process.env.APP_REACT,
  //   entry: process.env.NODE_ENV === 'development' ? 'http://localhost:8899/subapp/react/' : 'https://test.osisbim.com/subapp/react/',
  //   activeRule: '/react'
  // },
  // {
  //   name: 'sub-vue',
  //   entry: process.env.VUE_APP_SUB_VUE,
  //   activeRule: '/sub-vue'
  // },
  // {
  //   name: 'sub-html',
  //   entry: process.env.VUE_APP_SUB_HTML,
  //   activeRule: '/sub-html'
  // },
  // {
  //   name: 'organization',
  //   entry: 'http://localhost:8003/',
  //   activeRule: '/organization'
  // },
  // {
  //   name: 'region',
  //   entry: process.env.NODE_ENV === 'development' ? 'http://localhost:8002/subapp/region/' : 'https://test.osisbim.com/subapp/region/',
  //   activeRule: '/region'
  // },
  {
    name: process.env.VUE_APP_TEAMAKNOWLEDGE,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMAKNOWLEDGE}/`,
    activeRule: location => location.pathname.startsWith(`/${process.env.VUE_APP_TEAMAKNOWLEDGE}`)
  },
  {
    name: process.env.VUE_APP_TEAMSPROJECT,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMSPROJECT}/`,
    activeRule: `/${process.env.VUE_APP_TEAMSPROJECT}`
  },
  {
    name: process.env.VUE_APP_TEAMSPHONEH5,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMSPHONEH5}/`,
    activeRule: `/${process.env.VUE_APP_TEAMSPHONEH5}`
  },
  {
    name: process.env.VUE_APP_TEAMSCALC,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMSCALC}/`,
    activeRule: `/${process.env.VUE_APP_TEAMSCALC}`
  },
  {
    name: process.env.VUE_APP_TEAMSBACKEND,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMSBACKEND}/`,
    activeRule: `/${process.env.VUE_APP_TEAMSBACKEND}`
  },
  {
    name: process.env.VUE_APP_DATA,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_DATA}/`,
    activeRule: `/${process.env.VUE_APP_DATA}`
  },
  {
    name: process.env.VUE_APP_OSIS,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_OSIS}/`,
    activeRule: `/${process.env.VUE_APP_OSIS}`
  },
  {
    name: process.env.VUE_APP_FEATURE,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_FEATURE}/`,
    activeRule: `/${process.env.VUE_APP_FEATURE}`
  },
  {
    name: process.env.VUE_APP_HOME,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_HOME}/`,
    activeRule: `/${process.env.VUE_APP_HOME}`
  },
  {
    name: process.env.VUE_APP_EXAM,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_EXAM}/`,
    activeRule: `/${process.env.VUE_APP_EXAM}`
  },
  // {
  //   name: process.env.VUE_APP_TEAMSFILESTORE,
  //   entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_TEAMSFILESTORE}/`,
  //   activeRule: location => location.pathname.startsWith(`/${process.env.VUE_APP_TEAMSFILESTORE}`)
  // }
  {
    name: process.env.VUE_APP_GOALADMIN,
    entry: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : window.location.origin + `${process.env.VUE_APP_SUBPATH}/${process.env.VUE_APP_GOALADMIN}/`,
    activeRule: `/${process.env.VUE_APP_GOALADMIN}`
  }
]

const apps = microApps.map(item => {
  return {
    ...item,
    container: '#subapp-viewport', // 子应用挂载的div
    props: {
      routerBase: item.activeRule, // 下发基础路由
      getGlobalState: store.getGlobalState // 下发getGlobalState方法
    }
  }
})

export default apps
